import {inject, Injectable} from '@angular/core';
import {SecurityService} from '@core/service/security-service';
import {Store} from '@ngrx/store';
import {combineLatest, map} from 'rxjs';
import * as SecurityActions from '@core/ngrx/actions/security.actions';
import {selectPermissions, selectRoles} from '@core/ngrx/selectors/security.selectors';
import {RoleModel} from "@core/model/aux/role.model";
import {Actions, ofType} from "@ngrx/effects";
import {auditActions} from '@core/ngrx/actions'
import {AuditLog} from "@core/model/audit-log";

@Injectable({providedIn: 'root'})
export class SecurityFacade {
  private store = inject(Store);
  private securityService = inject(SecurityService);
  private actions$ = inject(Actions);

  readonly roles$ = this.store.select(selectRoles);
  readonly permissions$ = this.store.select(selectPermissions);

  readonly vm$ = combineLatest([
    this.listenToLoadAuditsSuccess$()
  ]).pipe(
    map(([auditAction]) => ({
      audits: auditAction.response.data as AuditLog[],
      totalRecords: auditAction.response.total,
    }))
  )

  readonly userAccess$ = combineLatest([this.roles$, this.permissions$]).pipe(
    map(([roles, permissions]) => ({roles, permissions}))
  );

  getAuditLogs(params: any) {
    this.store.dispatch(auditActions.loadAudits({params: params}));
  }

  loadUserAccessFromToken(token: string) {
    if (token) {
      this.updateStoreFromToken(token);
    }
  }

  public listenToLoadAuditsSuccess$() {
    return this.actions$.pipe(
      ofType(auditActions.loadAuditsSuccess.type),
    )
  }

  private updateStoreFromToken(token: string) {
    const payload = this.securityService.decodeJwt(token);
    const roles = payload?.['cognito:groups'] || [];
    const permissions = payload?.['scope'] ? payload['scope'].split(' ') : [];

    this.store.dispatch(SecurityActions.setUserAccess({roles, permissions}));
  }
}
